class Filters {
	constructor() {
		this.medialibrary = document.querySelector('.post-type-archive-documents');
		if (!this.medialibrary) {
			return;
		}

		this.filtersTags = this.medialibrary.querySelectorAll(".tag[data-category]");
		this.resetButton = this.medialibrary.querySelector(".reset-button");
		this.mediaCard = this.medialibrary.querySelectorAll('.document-card');

		this.resetButton.classList.add('focus');
		this.filterDocuments();
		this.resetFilters();
	}

	filterDocuments() {
		this.filtersTags.forEach(tagButton => {
			tagButton.addEventListener('click', e => {
				e.preventDefault();
				this.resetButton.classList.remove('focus');

				// const tagValue = e.currentTarget.dataset.category;
				//const goodDocumentCard = document.querySelectorAll(`.document-card[data-category="${e.currentTarget.dataset.category}"]`);
				this.mediaCard.forEach(card => {
					if (card.dataset.category !== e.currentTarget.dataset.category) {
						card.classList.add('hidden');
					} else {
						card.classList.remove('hidden');
					}
				});
			});
		});
	}

	resetFilters() {
		this.resetButton.addEventListener('click', () => {
			this.medialibrary.querySelectorAll('.document-card.hidden').forEach(item => {
				item.classList.remove('hidden');
			});
		});
	}

	bindEvent() {

	}
}